import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { AccountPage } from './pages/account/account.page';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginPage } from './pages/login/login.page';
import { ConfirmEmailPage } from './pages/confirm-email/confirm-email.page';
import { UserDataPage } from './pages/user-data/user-data.page';
import { ComponentsModule } from './components/components.module';
import { BillingPage } from './pages/billing/billing.page';
import { SupportChatPage } from './pages/support-chat/support-chat.page';
import { AffiliatePage } from './pages/affiliate/affiliate.page';
import { VcaasPage } from './pages/vcaas/vcaas.page';
import { McpPage } from './pages/mcp/mcp.page';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CeoUserDetailModule } from './pages/ceo/components/ceo-user-detail/ceo-user-detail.module';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent, AccountPage, LoginPage, ConfirmEmailPage, UserDataPage, BillingPage, SupportChatPage, AffiliatePage, VcaasPage, McpPage],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    // The support chat opens the very same customer panel the CEO users page does.
    CeoUserDetailModule,
    RecaptchaV3Module,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKey,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
